import { useQuery } from '@tanstack/react-query';
import { API_BASE_URL } from '@/config/api';
import { apiService, AUTH_EXPIRED_EVENT } from './apiService';

export interface FestivalSettings { enabled: boolean; effectsEnabled: boolean; revision: number }
export const FESTIVAL_QUERY = ['storefront-festival-theme'] as const;
async function read(signal?: AbortSignal): Promise<FestivalSettings> {
  const response = await fetch(`${API_BASE_URL}/read/v1/service/festival-theme`, { signal });
  if (!response.ok) throw new Error('The festival settings could not be loaded.');
  return response.json();
}
export const useFestivalSettings = () => useQuery({ queryKey: FESTIVAL_QUERY, queryFn: ({ signal }) => read(signal), staleTime: 30_000, refetchInterval: 60_000, retry: 1 });
export async function saveFestivalSettings(settings: FestivalSettings): Promise<FestivalSettings> {
  const response = await fetch(`${API_BASE_URL}/api/admin/festival-theme`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json', token: apiService.getToken() || '' },
    body: JSON.stringify({ enabled: settings.enabled, effectsEnabled: settings.effectsEnabled, expectedRevision: settings.revision }),
  });
  if (response.status === 401) { apiService.setToken(null); window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT)); }
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'The festival settings could not be saved.');
  return result;
}
